module.exports = __webpack_public_path__ + "static/media/video-icon.480d3bc0.svg";